module.exports = __webpack_public_path__ + "static/img/bg1.af96e4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/home/bg1.jpg
// module id = X1dm
// module chunks = 3